
<template>
  <!-- 日志查看 -->
  <div chass="app-container">
    <div class="chart-container">
      <div style="width:100%;float:left;margin-top:10px;">
        <el-select v-model="querydata.platformType" @change="mohuchaxunpt" size="mini" popper-class="select-box1" placeholder="" style="width:200px;float:left;margin-left:15px;">
          <el-option-group label="客户端事件">
            <el-option label="Android" value="ANDROID"></el-option>
            <el-option label="IOS" value="IOS"></el-option>
            <el-option label="HarmonyOs" value="HarmonyOs"></el-option>
            <el-option label="PC" value="PC"></el-option>
            <el-option label="Web" value="WEB"></el-option>
          </el-option-group>
          <el-option-group label="服务端事件">
            <el-option label="SERVER" value="SERVER"></el-option>
            <el-option label="SERVER_TEST" value="SERVER_TEST"></el-option>
          </el-option-group>
        </el-select>
        <el-input size="mini" v-if="querydata.platformType=='ANDROID'||querydata.platformType=='IOS'||querydata.platformType=='PC'||querydata.platformType=='WEB'" style="width:200px;float:left;margin-left:15px;"
          v-model="querydata.clientVersion" placeholder="客户端版本：client_version"></el-input>

        <el-input size="mini" style="width:200px;float:left;margin-left:15px;" v-model="querydata.serverId" placeholder="请输入区服ID"></el-input>

        <el-input size="mini" style="width:200px;float:left;margin-left:15px;" v-model="querydata.channelId" placeholder="注册渠道，即：channel_id"></el-input>

        <el-input size="mini" style="width:200px;float:left;margin-left:15px;" v-model="querydata.appChannelId" placeholder="次级渠道，即：app_channel_id"></el-input>

      </div>

      <div style="width:100%;float:left;margin-top:10px;">
        <el-input size="mini" style="width:200px;float:left;margin-left:15px;" v-model="querydata.deviceId" placeholder="设备ID，即：deviceId"></el-input>
        <el-input size="mini" style="width:200px;float:left;margin-left:15px;" v-model="querydata.userId" placeholder="账号ID,SDK关联ID即：userId"></el-input>

        <el-input size="mini" style="width:200px;float:left;margin-left:15px;" v-model="querydata.roleKey" placeholder="角色唯一key，即：roleKey"></el-input>

        <el-input size="mini" style="width:200px;float:left;margin-left:15px;" v-model="querydata.roleId" placeholder="角色ID，即：roleId"></el-input>

        <el-date-picker unlink-panels  size="mini" v-model="selectdate" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
          :picker-options="pickerOptions0" style="width:340px;float:left;margin-left:15px;margin-bottom:10px"></el-date-picker>

        <el-button type="primary" size="mini" @click="mohuchaxun" style="margin-left:15px;float:left;margin-bottom:10px" :loading="modelloading">查询</el-button>
        <el-button slot="reference" size="mini" title="下载" icon="el-icon-download" style="font-size: 16px;padding:5px 15px;float:left;margin-left:15px" @click="houtaixiazai"></el-button>
      </div>

      <div style="width:98%;float:left;margin-left:1%;padding:5px 0px;">
        <el-radio :label="''" v-model="allcode" @change="closeTags">全部</el-radio>
        <el-tag type="danger">仅支持7日内查询，多选时最多选择10个</el-tag>
        <div :style="{height: tableHeight + 'px',width:'100%',minHeight: '100px'}">

          <el-checkbox-group v-model="querydata.eventCode" style="width:100%">
            <el-scrollbar style="width:100%;" :style="{height: tableHeight + 'px',minHeight: '100px'}">
              <div v-for="item in radiolist" :key="item.type" class="radiolist" style="width:100%;float:left;">
                <span v-if="item.list.length>0">
                  <span style="float:left;line-height:30px;font-size:14px;width:5.5%">{{item.type}}：</span>
                  <div style="float:left;width:94.5%">
                    <el-checkbox v-for="itemlist in item.list" :key="itemlist.eventCode" :label="itemlist.eventCode" style="margin-top:8px;width:12%" @change="radiolistchange($event,itemlist)" :disabled="querydata.eventCode.length>9 && querydata.eventCode.indexOf(itemlist.eventCode)<0">
                      <span style="font-size:12px;color:#666">{{itemlist.eventName}}</span>
                    </el-checkbox>
                  </div>
                </span>
              </div>
            </el-scrollbar>
          </el-checkbox-group>
        </div>
        <div id="touchmove" style="width: 100%;margin-top:5px;margin-bottom:5px;height: 2px;background: #ababab;cursor: s-resize">
        </div>
        <div style="font-size:14px;color:#666" v-if="eventTags.length>0">
          已选事件：
          <el-tag style="margin-left:10px" size="mini" :key="tag.eventCode" v-for="tag in eventTags" closable :disable-transitions="false" @close="handleClose(tag)">
            {{tag.eventName}}
          </el-tag>
          <el-button class="button-new-tag" style="margin-left:20px" size="mini" @click="closeTags">清空</el-button>
        </div>
      </div>

      <div style="width:100%;float:left;min-height:500px" v-loading="modelloading">
        <el-table :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'8px 6px !important'}" :data="tableData3" class="tb-edit tb-editrizhichakan" border>
          <el-table-column prop="time" label="时间" width="150">
          </el-table-column>
          <el-table-column prop="eventName" label="事件名称" width="150">
          </el-table-column>
          <el-table-column prop="content" label="日志内容">
            <template slot-scope="scope">
              <div :style="{height : scope.row.open ? 'auto': '36px'}" style="border:1px solid #dedede;border-radius: 6px;padding:5px;overflow:hidden" v-html="scope.row[scope.column.property]"></div>
              <el-button size="mini" style="padding:0px;position:absolute;top:20px;right:14px" type="text" @click="scope.row.open = !scope.row.open">{{scope.row.open ? '↑ 收起' : '↓ 展开'}}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="checkStatus" label="格式校验" width="120">
            <template slot-scope="scope">
              {{scope.row[scope.column.property] | checkStatuss}}
            </template>
          </el-table-column>
          <el-table-column prop="errorMsg" label="错误提示">
          </el-table-column>
        </el-table>

        <div class="block" style="padding-bottom:10px">
          <el-pagination :current-page="querydata.pageNo" :page-sizes="[10,15, 20, 30, 50]" :page-size="querydata.pageSize" layout="->,total,sizes,  prev, pager, next, jumper" :pager-count="5" :total="dataLength3"
            style="margin-top:10px;" @size-change="handleSizeChange3" @current-change="handleCurrentChange3" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import splitPane from 'vue-splitpane'
import { logViewquery, logViewgetAllEvent, houtaixiazairenwu } from "@Bdc~/api/ajax_model";
import DatePicker from "@Sys~/components/DatePicker"
export default {
  components: { splitPane, DatePicker },
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              //console.log(picker)
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              const end = new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000);
              start.setTime(start.getTime());
              picker.$emit('pick', [start, end]);
            }
          },

          {
            text: '昨天',
            onClick(picker) {
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              const end = new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000);
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '过去7天',
            onClick(picker) {
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              const end = new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000);
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          }
        ],
        disabledDate(time) {
          return time.getTime() > new Date(new Date().setTime(new Date().getTime() + 3600 * 1000 * 24 * 1))
        }
      },
      modelloading: false,
      selectdate: [],
      allcode: "",
      querydata: {
        platformType: "ANDROID",
        eventCode: [],
        serverId: "",
        userId: "",
        roleId: "",
        roleKey: "",
        deviceId: "",
        queryTime: "",
        channelId: "",
        appChannelId: "",
        clientVersion: "",
        pageSize: 10,
        pageNo: 1
      },
      radiolist: [
        {
          type: "P1",
          list: []
        },
        {
          type: "P2",
          list: []
        },
        {
          type: "P3",
          list: []
        },
        {
          type: "自定义",
          list: []
        }
      ],

      tableData3: [],
      currentPage3: 1,
      dataLength3: 1,
      sizePage3: 10,

      eventTags: [],

      innerHeight: window.innerHeight, // 获取窗口高度
      tableHeight: 150, // 设置第一个div的高度为窗口高度的一半
    };
  },
  created() {
    this.logViewgetAllEvent();
    this.logViewquery();
  },
  mounted() {
    document.getElementById("touchmove").onmousedown = this.textWidthChange;
  },
 watch: {
    // 筛选table header
    eventTags(val, oldVal){//普通的watch监听
         if(val == ""){
           this.allcode = ""
         }else{
           this.allcode = "1"
         }
     },
  },
  methods: {
    handleClose(tag) {
      this.eventTags.splice(this.eventTags.indexOf(tag), 1);
      this.querydata.eventCode.forEach((item) => {
        console.log(tag.eventCode , item)
        if(tag.eventCode == item){
          this.querydata.eventCode.splice(this.querydata.eventCode.indexOf(item), 1);
        }
      })

      if (this.eventTags.length <= 0) {
        this.eventTags = [];
        this.allcode = "";
        this.querydata.eventCode = []
      }
      this.logViewquery()
    },
    closeTags() {
      this.eventTags = [];
      this.allcode = "";
      this.querydata.eventCode = []
      this.logViewquery()
    },
    textWidthChange(e) {
      let that = this
      let dy = e.clientY;//当你第一次单击的时候，存储Y轴的坐标。
      document.onmousemove = e => {
        if (e.clientY > that.innerHeight) {
          return
        }
        if (e.clientY < dy) {
          that.tableHeight -= (dy - e.clientY)
        } else {
          that.tableHeight += (e.clientY - dy)
        }
        dy = e.clientY
      };
      document.onmouseup = e => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
      e.stopPropagation();
      e.preventDefault();
      return false;
    },
    logViewquery() {
      console.log(this.selectdate)
      if (this.selectdate == "" || this.selectdate == null) {
        this.querydata.queryTime = "" 
      }else{
        this.querydata.queryTime = this.selectdate[0] + " - " + this.selectdate[1];
      }

      var datas = JSON.parse(JSON.stringify(this.querydata))
      datas.eventCode = String(this.querydata.eventCode)
      console.log(datas);
      this.modelloading = true;
      logViewquery(datas).then(response => {
        console.log(response);
        this.modelloading = false;
        if (response.code == 1) {
          for (var i = 0; i < response.data.aaData.length; i++) {
            response.data.aaData[i].open = false;
          }

          this.tableData3 = response.data.aaData;
          this.dataLength3 = response.data.iTotalRecords;
        }
      });
    },
    logViewgetAllEvent() {
      logViewgetAllEvent(this.querydata.platformType).then(
        response => {
          console.log(response);
          this.radiolist = [
            {
              type: "P1",
              list: []
            },
            {
              type: "P2",
              list: []
            },
            {
              type: "P3",
              list: []
            },
            {
              type: "自定义",
              list: []
            }
          ];
          if (response.code == 1) {
            for (var i = 0; i < response.data.length; i++) {
              if (response.data[i].eventLevel == "1") {
                this.radiolist[0].list.push(response.data[i]);
              } else if (response.data[i].eventLevel == "2") {
                this.radiolist[1].list.push(response.data[i]);
              } else if (response.data[i].eventLevel == "3") {
                this.radiolist[2].list.push(response.data[i]);
              } else if (response.data[i].eventLevel == "4") {
                this.radiolist[3].list.push(response.data[i]);
              }
            }
          }
        }
      );
    },
    mohuchaxun() {
      // this.selectdate = this.$refs.datepicker.selectdate
      this.querydata.pageNo = 1;
      this.logViewquery();
    },
    mohuchaxunpt() {
      this.eventTags = [];
      this.allcode = "";
      this.querydata.eventCode = []

      this.querydata.clientVersion = "";
      // this.querydata.eventCode = "";
      this.querydata.pageNo = 1;
      this.logViewgetAllEvent();
      this.logViewquery();
    },
    handleSizeChange3(e) {
      // table 分页数量变化
      this.sizePage3 = e;
      this.querydata.pageNo = 1;
      this.querydata.pageSize = e;
      this.logViewquery();
    },
    handleCurrentChange3(e) {
      // table 分页变化
      this.querydata.pageNo = e;
      this.logViewquery();
    },
    radiolistchange(e, v) {
      console.log(e, v)
      // this.querydata.eventCode = e;
      // this.logViewquery();
      if (e) {
        this.eventTags.push(v);
      } else {
        this.eventTags.splice(this.eventTags.indexOf(v), 1);
      }
    },
    houtaixiazai() {
      var zitiaojian = JSON.parse(JSON.stringify(this.querydata))
      delete zitiaojian.pageSize
      delete zitiaojian.pageNo
      houtaixiazairenwu(
        {
          header_view_code: "3_1_4",
          header_time_type: "0m",
        },
        zitiaojian).then(response => {
          console.log(response);
          if (response.code == 1) {
            this.$message.success("下载任务提交成功，请到下载管理页面查看下载进度")
          };
        })
    },
  },
  filters: {
    checkStatuss(value) {
      if (value == "1") {
        return "格式正确";
      } else if (value == "2") {
        return "格式错误";
      } else {
        return "未知状态";
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-container {
  background-color: #364652;
}
.chart-container {
  position: relative;
  // padding: 15px;
  padding-bottom: 1px;
  /* width: 100%;
    height: 30%; */
  // background-color: #f0efef;
}
.ibox-title {
  line-height: 32px;
  padding: 4px 15px 3px;
}

/* .grid-content  */
.ibox-title {
  border-bottom: 1px solid #dedede;
}
.ibox-content {
  border: none;
}
.ibox-title h5 {
  margin: 0;
}
.tb-edit {
  width: 98%;
  margin-left: 1%;
  margin-top: 15px;
  font-size: 12px !important;
}
/* .el-table th{background:#fff;} */
</style>

<style>
.el-dialog__body {
  padding: 10px 5px;
}
.el-tabs__header {
  margin-bottom: 0px;
}
.el-tabs__nav {
  /* margin-left: 30px;
  margin-right: 30px; */
}
.el-row {
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #fff;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 30px;
  /* padding-bottom: 15px; */
}
.row-bg {
  /* padding: 10px 0; */
  background-color: #f9fafc;
}
.tb-editrizhichakan tr td .cell {
  line-height: 14px;
  padding: 0px 10px !important;
}

.el-table th {
  background-color: #fff;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.panel-group {
  // margin-top: 18px;
  .card-panel-col {
    // margin-bottom: 32px;
  }
  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.1);
    border-color: rgba(0, 0, 0, 0.05);
    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }
      .icon-people {
        background: #40c9c6;
      }
      .icon-message {
        background: #36a3f7;
      }
      .icon-money {
        background: #f4516c;
      }
      .icon-shoppingCard {
        background: #34bfa3;
      }
    }
    .icon-people {
      color: #40c9c6;
    }
    .icon-message {
      color: #36a3f7;
    }
    .icon-money {
      color: #f4516c;
    }
    .icon-shoppingCard {
      color: #34bfa3;
    }
    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }
    .card-panel-icon {
      float: left;
      font-size: 48px;
    }
    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }
      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}
</style>
<style>
.aaa {
  text-align: center;
}
.shishitophuizong {
  width: 16.6%;
  float: left;
  text-align: center;
}
.shishitophuizong1 {
  font-size: 14px;
  font-weight: 600;
  padding: 5px 0px;
}
.shishitophuizong2 {
  font-size: 30px;
  font-weight: 100;
  padding: 5px 0px;
}
.shishitophuizong3 {
  font-size: 12px;
  font-weight: 100;
  padding: 5px 0px;
}
.shishitophuizong1 icon {
  width: 15px;
  height: 15px;
}

.shishitophuizonger {
  width: 16.6%;
  float: left;
  text-align: center;
  border-top: 1px solid #e7eaec;
  padding: 8px 0px;
  vertical-align: middle;
  color: #337ab7;
  font-size: 14px;
}
.el-tag {
  background: none;
  border: none;
}

.zhibiaoshuoming {
  font-size: 12px;
  color: #999;
}
.zhibiaoshuoming_title {
  font-size: 14px;
  color: #666;
  display: block;
  border-bottom: 1px solid #dedede;
  padding-bottom: 10px;
}
.el-loading-mask {
  z-index: 5;
}
.disqudao {
  display: none;
}

.tianjiastyle,
.tianjiastyle1 {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
}
.tianjiastyle_bg,
.tianjiastyle_bg1 {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
}
.tianjiastyle_content {
  width: 720px;
  background: #fff;
  padding: 20px;
  position: absolute;
  top: 50px;
  left: 50%;
  margin-left: -350px;
  border: 1px solid #dedede;
}
.tianjiastyle_content1 {
  width: 90%;
  background: #fff;
  padding: 20px;
  position: absolute;
  top: 50px;
  left: 5%;
  border: 1px solid #dedede;
}
.wubaobiao {
  width: 300px;
  height: 200px;
  text-align: center;
  background: #fff;
  margin-bottom: 600px;
  color: #1890ff;
  position: relative;
  left: 50%;
  margin-left: -150px;
  top: 150px;
}
.radiolist .el-radio__inner {
  width: 12px;
  height: 12px;
}
.yindaodiv {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: rgba(0, 0, 0, 0.2);
  z-index: 99999;
}
</style>
<style lang="scss">
.select-box1 {
  height: 340px;
  .el-scrollbar{
    height: 340px;
    .el-select-dropdown__wrap{
      max-height: 340px;
    }
  }
}
</style>